<template>
    <div>
        <portcall-list v-if="isPortcallSidebarVisible" is-from-custom-sidebar />
        <quay-list v-else-if="isQuaySidebarVisible" is-from-custom-sidebar />
    </div>
</template>

<script>
    import PortcallList from '@/components/port-call-components/PortcallList';
    import QuayList from '@/components/quay-components/QuayList';
    import { mapGetters } from 'vuex';
    export default {
        name: 'CustomSidebar',
        components: { QuayList, PortcallList },
        computed: {
            ...mapGetters(['customLayout', 'sidebarValue']),
            isPortcallSidebarVisible() {
                return (
                    this.customLayout.portcall.some(element => element.name === 'Portcall List' && element.checked) &&
                    this.sidebarValue === 'portcall'
                );
            },
            isQuaySidebarVisible() {
                return (
                    this.customLayout.quay.some(element => element.name === 'Quay List' && element.checked) &&
                    this.sidebarValue === 'quay'
                );
            },
        },
        mounted() {
            this.$store.commit('setSidebarValue', false);
        },
    };
</script>
